// Module
var code = "<div class=\"fc-progress__line\" data-bind=\"style: {\n  width: percent() + '%'\n}\"></div>\n";
// Exports
module.exports = code;